import React, { useEffect, useState } from "react";
import { Table } from 'react-bootstrap';
import { Loading, Pagination } from "../../../../../../common";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { url } from "../../../../../../config";
const axios = require("axios").default;

export default function MyGroups({ onClickShowDetail }) {
    const [myGroups, setMyGroups] = useState({ page: 0, totalPage: 0, totalElements: 0, data: [] });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadMyGroups(0);

        window.addEventListener("reload-my-groups", () => { loadMyGroups(myGroups.page) });
    }, [])

    const loadMyGroups = (page) => {
        axios.get(url + "/private/rest/kuzel-group/my-groups/detailed?page=" + page + "&size=5")
            .then(res => {
                setMyGroups(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            });
    }

    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th className="col-5">Názov</th>
                        <th className="col-3">Počet členov</th>
                        <th className="col-3 d-none d-lg-table-cell">Počet udalostí</th>
                        <th className="col-2 col-lg-1"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ? (
                            <tr className="text-center">
                                <td colSpan="100%" className="border-0">
                                    <Loading marginTop='80px'></Loading>
                                </td>
                            </tr>
                        ) : (
                            myGroups.data.map((group, index) => {
                                return (
                                    <tr key={index} onClick={() => onClickShowDetail(group)} role="button">
                                        <td>{group.name}</td>
                                        <td>{group.membersCount}</td>
                                        <td className="d-none d-lg-table-cell">{group.kuzelCount}</td>
                                        <td>
                                            <FontAwesomeIcon className="text-secondary" icon="fa-solid fa-people-group"  />
                                            <FontAwesomeIcon className="text-secondary ms-2" icon={(group.role == 'ADMIN' ? 'fa-solid fa-gear' : '')} />
                                        </td>
                                    </tr>
                                )
                            })
                        )
                    }
                </tbody>
            </Table>

            <div className="d-flex justify-content-center">
                <Pagination page={myGroups.page} totalPages={myGroups.totalPage} onPageChange={page => loadMyGroups(page)} />
            </div>
        </>
    );
}